<template>
    <div>
        <nav-bar style="background-color: #d43e2e">
            <link-mobile slot="left" link="/WordMobile"><</link-mobile>
            <div slot="center">我的设置</div>
            <link-mobile slot="right" link="/WordMoreMobile"><i class="el-icon-more"></i></link-mobile>
        </nav-bar>
        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                :pull-up-load="true">

        </Scroll>
    </div>
</template>

<script>
    import NavBar from "../../../components/navbar/NavBar";
    import Scroll from "../../../components/scroll/Scroll";
    import LinkMobile from "../../../components/link/LinkMobile";
    export default {
        name: "WordMoreMobile",
        components:{
            NavBar,
            Scroll,
            LinkMobile,
        }
    }
</script>

<style scoped>

</style>